import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: '¿Cuánto tiempo toma ver resultados?',
    answer: 'Generalmente, nuestros clientes empiezan a ver un incremento en llamadas y visitas en los primeros 30 a 45 días después de lanzar la estrategia optimizada.'
  }, {
    question: '¿Necesito saber de tecnología?',
    answer: '¡Para nada! Nosotros nos encargamos de toda la parte técnica. Tú solo te dedicas a atender a los nuevos clientes que llegarán a tu negocio.'
  }, {
    question: '¿Qué incluye el Pack Crecimiento?',
    answer: 'Incluye el diseño de tu página web optimizada para Google, gestión de tus perfiles en redes sociales (Instagram y Facebook), y configuración de Google Mi Negocio.'
  }, {
    question: '¿Puedo cancelar en cualquier momento?',
    answer: 'Sí, no tenemos contratos forzosos a largo plazo. Trabajamos mes a mes porque confiamos en que los resultados te harán quedarte.'
  }];
  return <section className="py-20 lg:py-24 bg-white" data-id="element-11">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-12">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-center text-dark mb-12" data-id="element-13">
          Preguntas frecuentes
        </motion.h2>

        <div className="space-y-4" data-id="element-14">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="border border-gray-200 rounded-xl overflow-hidden" data-id="element-15">
                <button className="w-full px-6 py-5 text-left flex justify-between items-center bg-white hover:bg-gray-50 transition-colors focus:outline-none" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} data-id="element-16">
                  <span className="font-bold text-dark pr-4" data-id="element-17">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 text-primary flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-18" />
                </button>
                <AnimatePresence initial={false} data-id="element-19">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-20">
                      <div className="px-6 pb-5 text-gray-600 border-t border-gray-100 pt-4" data-id="element-21">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}